import Cookies from "js-cookie";

export function isAuthValid() {
  const { token } = Cookies.getJSON("auth") || {};
  return !!token;
}
